import { ProductFormConfig } from 'modules/supplier/products';
import { OOHConfigForm } from './OOHConfigForm';

export const initialFormatValues = {
  quantity: 1,
};
export const oohProductConfig: ProductFormConfig = {
  Component: OOHConfigForm,
  initialValues: {
    format: initialFormatValues,
  },
};
